import { Component, OnInit } from '@angular/core';
import { AlertService, IAlertType, ProjectsStoreService } from '../../../_shared/services';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Projects } from '../../../_shared/interfaces';
import { ClrIconModule } from "@clr/angular";
import { ProjectFormComponent } from "../project-form/project-form.component";
import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-project-update',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    ProjectFormComponent,
    NgIf,
    JsonPipe
  ],
  providers: [DatePipe],
  templateUrl: './project-update.component.html',
  styleUrl: './project-update.component.sass'
})
export class ProjectUpdateComponent implements OnInit {
  companyId: number = 0;
  projectId: string = '';
  projects: Projects[] = [];
  devMode: boolean;

  constructor(
      private projss: ProjectsStoreService,
      private route: ActivatedRoute,
      private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(twoWayArrowsIcon)
  }

  /// Die Projektnummer wird ueberall vierstellig dargestellt (756.0065), im
  /// Titel dieses Formulars stand sie ungepolstert (756.65). Gleiche Logik wie
  /// `displayProjectId` in project-details.
  get displayProjectId(): string {
    const parsed = parseInt(this.projectId, 10);
    return Number.isFinite(parsed) ? parsed.toString().padStart(4, '0') : this.projectId;
  }


  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.companyId = parseInt(params.get('cid') ?? '0', 10);
    this.projectId = params.get('prid') ?? '0';
    this.loadProject(this.companyId, this.projectId);
  }

  loadProject(company: number, project: string){
    this.projss.filterProjectsPPS(company, project, 0, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Projektdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }

        this.projects = data.object;
        if (this.devMode) console.table(this.projects[0]);
      },
      complete: () => {},
      error: () => {
        return
      }
    })
  }
}
